import {useQuery} from '@tanstack/react-query'

import type {RestaurantListingProps} from '@/lib/food-grubhub/foodGrubhubModel'
import {getRestaurants} from '@/lib/food-grubhub/foodGrubhubService'

const useGrubhubRestaurantListing = (params: RestaurantListingProps, token: string) => {
  return useQuery({
    queryKey: ['restaurant', params, token],
    queryFn: async () =>
      getRestaurants({
        orderMethod: params.orderMethod ?? '',
        locationMode: params.locationMode ?? '',
        facetSet: params.facetSet ?? '',
        pageSize: params.pageSize ?? 0,
        hideHateos: params.hideHateos,
        searchMetrics: params.searchMetrics,
        queryText: params.queryText ?? '',
        location: params.location ?? '',
        preciseLocation: params.preciseLocation,
        geohash: params.geohash ?? '',
        includeOffers: params.includeOffers,
        featureControl: params.featureControl ?? '',
        sortSetId: params.sortSetId ?? '',
        sponsoredSize: params.sponsoredSize ?? 0,
        countOmittingTimes: params.countOmittingTimes,
        pageNum: params.pageNum ?? 1,
        sorts: params.sorts,
        facet: params.facet,
        token,
        signal: undefined,
      }),
    enabled: !!token,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    staleTime: 1000 * 60 * 5,
  })
}

export default useGrubhubRestaurantListing
